// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Bookmark_spinner__wYREI"};